/*
 * @Author: Dom
 * @Date: 2022-06-03 15:34:14
 * @LastEditTime: 2022-06-03 15:42:11
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\utils\copy.ts
 */
import {message} from 'ant-design-vue'

export function copyContent(cont:string):void{
    const input = document.createElement('input')
    input.value = cont
    document.body.appendChild(input)
    input.select()
    document.execCommand('copy')
    message.success('复制成功')
    document.body.removeChild(input)
}
